<template>
  <div class="underwrite-order-list">
    <el-card class="box-card">
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="被保险人">
            <el-input v-model="searchForm.company_name" placeholder="被保险人名称" clearable style="width: 160px;"></el-input>
          </el-form-item>

          <el-form-item label="订单状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 180px;">
              <el-option label="待人工审核" value="1"></el-option>
              <el-option label="补充资料待上传" value="2"></el-option>
              <el-option label="补充资料待审核" value="4"></el-option>
              <el-option label="预核保已通过" value="8"></el-option>
              <el-option label="已系统审核拦截" value="16"></el-option>
              <el-option label="已人工审核拦截" value="32"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="提交时间">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="客户类型">
            <el-select v-model="searchForm.custom_type" placeholder="请选择客户类型" clearable style="width: 150px;">
              <el-option label="普通客户" :value="1"></el-option>
              <el-option label="优质客户" :value="2"></el-option>
              <el-option label="黑名单客户" :value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="省份城市">
            <el-input v-model="searchForm.province" placeholder="省份" clearable style="width: 120px;"></el-input>
            <el-input v-model="searchForm.city" placeholder="城市" clearable style="width: 120px; margin-left: 8px;"></el-input>
          </el-form-item>

          <el-form-item label="渠道商">
            <el-autocomplete
              v-model="searchForm.channel"
              :fetch-suggestions="queryChannel"
              placeholder="渠道商"
              clearable
              style="width: 200px;"
              @select="handleChannelSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.name || item.realname }}<span v-if="item.alias"> ({{ item.alias }})</span></div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel">导出Excel</el-button>
            <el-button type="warning" @click="handleAddOrder">添加订单</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%" border v-loading="loading">
        <el-table-column prop="policyholder" label="被保险人" width="180" align="center" />
        <el-table-column prop="status" label="预核保进度" width="140" align="center" :formatter="statusFormat" />
        <el-table-column prop="refusal_reason" label="审核理由" width="180" align="center" :formatter="reasonFormat" />
        <el-table-column prop="custom_type" label="客户类型" width="100" align="center" :formatter="customTypeFormat" />
        <el-table-column prop="top_channel_name" label="顶级渠道" width="100" align="center" />
        <el-table-column prop="channel_name" label="直属渠道" width="150" align="center" />
        <el-table-column prop="business_income" label="营收收入(万元)" width="120" align="center" :formatter="coverageFormat" />
        <el-table-column prop="single_coverage" label="单次限额(万元)" width="130" align="center" :formatter="coverageFormat" />
        <el-table-column prop="total_coverage" label="累计限额(万元)" width="130" align="center" :formatter="coverageFormat" />
        <el-table-column prop="extend" label="扩展需求" width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="last_compensation" label="去年赔付情况" width="150" align="center" show-overflow-tooltip />
        <el-table-column prop="note" label="备注" width="150" align="center" show-overflow-tooltip />
        <el-table-column prop="province" label="省份" width="100" align="center" />
        <el-table-column prop="city" label="城市" width="80" align="center" />
        <el-table-column prop="created_at" label="创建时间" width="160" align="center" :formatter="dateFormat" />
        <el-table-column prop="updated_at" label="更新时间" width="160" align="center" :formatter="dateFormat" />
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleView(scope.row.id)">查看详情</el-button>
            <el-button type="text" :style="{ color: scope.row.is_have && scope.row.status === 4 ? 'red' : '' }" @click="handleViewDatum(scope.row.id)">查看补充资料</el-button>
            <el-button type="text" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="text" style="color: #F56C6C;" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;"
      />
    </el-card>

    <!-- 添加/编辑订单弹窗 -->
    <OrderSave
      :visible.sync="orderSaveVisible"
      :order-id="currentOrderId"
      :mode="saveMode"
      @success="fetchData"
    />

    <!-- 查看补充资料弹窗 -->
    <DatumView
      :visible.sync="datumViewVisible"
      :order-id="currentOrderId"
    />

    <!-- 查看详情弹窗 -->
    <OrderDetails
      :visible.sync="orderDetailsVisible"
      :order-id="currentOrderId"
      @success="fetchData"
    />
  </div>
</template>

<script>
import ExportJsonExcel from 'js-export-excel'
import { getUnderwriteOrderList, deleteUnderwriteOrder } from '@/api/underwrite-order'
import { getChannelList } from '@/api/channel'
import OrderSave from './components/OrderSave.vue'
import DatumView from './components/DatumView.vue'
import OrderDetails from './components/OrderDetails.vue'

export default {
  name: 'UnderwriteOrderList',
  components: { OrderSave, DatumView, OrderDetails },
  data() {
    return {
      loading: false,
      searchForm: {
        company_name: '',
        status: '',
        dateRange: [],
        custom_type: '',
        province: '',
        city: '',
        channel: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      channelList: [],
      selectedChannel: null,
      // 弹窗控制
      orderSaveVisible: false,
      datumViewVisible: false,
      orderDetailsVisible: false,
      currentOrderId: null,
      saveMode: 'add' // add | edit
    }
  },
  created() {
    this.fetchData()
    this.fetchChannelList()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          ...this.buildSearchParams()
        }
        const res = await getUnderwriteOrderList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || (res.rows ? res.rows.length : 0)
      } catch (e) {
        this.$message.error('获取订单列表失败')
      } finally {
        this.loading = false
      }
    },
    buildSearchParams() {
      const p = {}
      if (this.searchForm.company_name) p.company_name = this.searchForm.company_name
      if (this.searchForm.status) p.status = this.searchForm.status
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        p.begin_date = Math.floor(this.searchForm.dateRange[0] / 1000)
        p.end_date = Math.floor(this.searchForm.dateRange[1] / 1000)
      }
      if (this.searchForm.custom_type) p.custom_type = this.searchForm.custom_type
      if (this.searchForm.province) p.province = this.searchForm.province
      if (this.searchForm.city) p.city = this.searchForm.city
      if (this.searchForm.channel && this.selectedChannel) {
        p.channel_id = this.selectedChannel.id
      }
      return p
    },
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (e) {
        // ignore
      }
    },
    queryChannel(queryString, cb) {
      const results = queryString
        ? this.channelList.filter(item => {
            const name = (item.name || item.realname || '').toLowerCase()
            const alias = (item.alias || '').toLowerCase()
            const q = queryString.toLowerCase()
            return name.includes(q) || alias.includes(q)
          })
        : this.channelList
      cb(results)
    },
    handleChannelSelect(item) {
      this.selectedChannel = item
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    handleReset() {
      this.searchForm = {
        company_name: '',
        status: '',
        dateRange: [],
        custom_type: '',
        province: '',
        city: '',
        channel: ''
      }
      this.selectedChannel = null
      this.pagination.currentPage = 1
      this.fetchData()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.fetchData()
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.fetchData()
    },
    // 操作按钮
    handleAddOrder() {
      this.currentOrderId = null
      this.saveMode = 'add'
      this.orderSaveVisible = true
    },
    handleEdit(row) {
      this.currentOrderId = row.id
      this.saveMode = 'edit'
      this.orderSaveVisible = true
    },
    handleView(id) {
      this.currentOrderId = id
      this.orderDetailsVisible = true
    },
    handleViewDatum(id) {
      this.currentOrderId = id
      this.datumViewVisible = true
    },
    handleDelete(id) {
      this.$confirm('您确定要删除该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteUnderwriteOrder({ id: id * 1 })
          if (res.err_code === 0) {
            this.$message.success('删除成功')
            this.fetchData()
          } else {
            this.$message.error(res.err_msg || '删除失败')
          }
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    async handleExportExcel() {
      try {
        const params = { ...this.buildSearchParams() }
        const res = await getUnderwriteOrderList(params)
        const rows = res.rows || []
        if (!rows.length) {
          this.$message.warning('没有数据可导出')
          return
        }
        const datas = [{
          sheetData: rows.map(r => ({
            '被保险人': r.policyholder,
            '预核保订单进度': this.statusFormat(r.status),
            '审批理由': this.reasonFormat(r.refusal_reason),
            '客户类型': this.customTypeFormat(r.custom_type),
            '省份': r.province,
            '城市': r.city,
            '营收收入(万元)': this.coverageFormat(r.business_income),
            '单次限额(万元)': this.coverageFormat(r.single_coverage),
            '累计限额(万元)': this.coverageFormat(r.total_coverage),
            '扩展需求': r.extend,
            '去年赔付情况': r.last_compensation,
            '业务归属': r.channel_name,
            '备注': r.note,
            '提交时间': this.dateFormat(r.created_at),
            '更新时间': this.dateFormat(r.updated_at)
          })),
          sheetName: 'sheet',
          sheetHeader: ['被保险人', '预核保订单进度', '审批理由', '客户类型', '省份', '城市', '营收收入(万元)', '单次限额(万元)', '累计限额(万元)', '扩展需求', '去年赔付情况', '业务归属', '备注', '提交时间', '更新时间']
        }]
        const ex = new ExportJsonExcel({ fileName: '预核保-货运险年保订单', datas })
        ex.saveExcel()
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    // 格式化函数
    statusFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' && arg2 ? arg3 : arg1
      const map = {
        1: '待人工审核',
        2: '补充资料待上传',
        4: '补充资料待审核',
        8: '预核保已通过',
        16: '已系统审核拦截',
        32: '已人工审核拦截'
      }
      return map[v] || ''
    },
    reasonFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' && arg2 ? arg3 : arg1
      if (!v) return ''
      try {
        return JSON.parse(v)
      } catch (e) {
        return v
      }
    },
    customTypeFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' && arg2 ? arg3 : arg1
      const map = { 1: '普通客户', 2: '优质客户', 4: '黑名单客户' }
      return map[v] || '未知'
    },
    coverageFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === 'object' && arg2 ? arg3 : arg1
      if (v == null) return ''
      return (v / 10000).toFixed(2)
    },
    dateFormat(arg1, arg2, arg3) {
      const raw = typeof arg1 === 'object' && arg2 ? arg3 : arg1
      if (raw === undefined || raw === null || raw === '') return ''
      let ms = raw
      if (typeof raw === 'number') {
        ms = raw < 1e12 ? raw * 1000 : raw
      } else if (typeof raw === 'string') {
        if (/^\d+$/.test(raw)) {
          const num = Number(raw)
          ms = num < 1e12 ? num * 1000 : num
        } else {
          ms = raw.replace(/-/g, '/').replace('T', ' ').replace(/Z$/i, '')
        }
      } else {
        return ''
      }
      const d = new Date(ms)
      if (!d || isNaN(d.getTime())) return ''
      if (d.getFullYear() <= 1971) return ''
      const pad = n => (n < 10 ? '0' + n : n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }
  }
}
</script>

<style lang="less" scoped>
.underwrite-order-list {
  .search-toolbar {
    margin-bottom: 12px;
  }
}
</style>
